// extracted by mini-css-extract-plugin
export var gif = "_jd-0";